<div class="ostso-dialog landmark">
  <div class="header">
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
    <h1>{{ isNew ? "Создание объекта" : "Редактирование объекта" }}</h1>

  </div>
  <div mat-dialog-content>
    <form class="form" [formGroup]="form">
      <div class="select-container">
        <!--        <div class="placeholder" *ngIf="!form.get('balanceHolder')!.value">Балансодержатель</div>-->
        <!--        <mat-select class="remarktype-textarea" formControlName="balanceHolder">-->
        <!--          @for (balanceHolder of balanceHolders; track balanceHolder.id) {-->
        <!--            <mat-option [value]="balanceHolder">-->
        <!--              {{ balanceHolder.name }}-->
        <!--            </mat-option>-->
        <!--          }-->
        <!--        </mat-select>-->
        <mat-form-field [hideRequiredMarker]="true">
          <mat-label>Балансодержатель</mat-label>
          @if (openedField()) {
            <mat-icon matSuffix>expand_less</mat-icon>
          } @else {
            <mat-icon matSuffix>expand_more</mat-icon>
          }
          <mat-icon matSuffix (click)="clearBalanceHolder()">clear</mat-icon>
          <input type="text" matInput [formControlName]="'balanceHolder'" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" (opened)="openedField.set(true)" (closed)="openedField.set(false)">
            @for (option of filteredOptions$ | async; track option) {
              <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <!--        <mat-form-field class="example-full-width">-->
        <!--          <mat-label>Assignee</mat-label>-->
        <!--          <input type="text" matInput formControlName="balanceHolder" [matAutocomplete]="auto">-->
        <!--          <mat-autocomplete #auto="matAutocomplete">-->
        <!--            @for (option of [1,2,3,4,5] ; track option) {-->
        <!--              <mat-option [value]="option">{{option}}</mat-option>-->
        <!--            }-->
        <!--          </mat-autocomplete>-->
        <!--        </mat-form-field>-->
      </div>
      <input class="remarktype-textarea" matInput [formControlName]="'egipRegistryNumber'"
             placeholder="Реестровый номер ИАС Спорт">
      <input class="remarktype-textarea" matInput [formControlName]="'name'" placeholder="Наименование объекта">
      <input class="remarktype-textarea" matInput [formControlName]="'facilityAddress'" placeholder="Адрес">
      <br/>
    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()" [disabled]="!form.valid">Применить
    </button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

